export default __webpack_public_path__ + "static/media/photo--lg--kickoff-group.0d80dbc5.jpg";